import type { SiteIO } from '@/api';
import LegalLandDescription from './LegalLandDescription';
import Coordinates from './Coordinates';
import Contaminant from './Contaminant';
import RiskManagementData from './RiskManagementData';

export const fileClassifications: Record<string, string> = {
    CSU: 'Contaminated Sites, Upstream',
    REC: 'Reclamation Certificates',
    PST: 'Petroleum Storage Tank',
    SCD: 'Site Assessments, Contaminated Sites, Cleanup, Decommissioning Facilities'
};

export default class ESARSite implements SiteIO {
    id = '';
    operationId = 0;
    numOfRecords = 0;
    dateFileOpened = '';
    lastAEPReply = '';
    lastItemInFileDate = '';
    operationName = '';
    municipality = '';
    city = '';
    neighborhood = '';
    operatorName = '';
    yearOfESAReport = '';
    environmentalConsultingCompany = '';
    specificActivityCode = '';
    oprAreaParcelId = 0;
    isThereRecordOfSiteCondition = '';
    statusOfSiteConditionRecord = '';
    currentSiteStatus = '';
    rationaleForSiteStatus = '';
    siteCriteriaSelection = '';
    // yearOfCriteriaSelection = '';
    criteriaCommentForSite = '';
    currentLeadRegulatoryAgency = '';
    currentSiteActivity = '';
    pastSiteActivity = '';
    statusOfContaminationEvent = '';
    eventCriteriaSelection = '';
    criteriaCommentForContaminationEvent = '';
    commentsForContaminationEvent = '';
    isDUAExcluded = '';
    DUADetails = '';
    isTier2FALExcluded = '';
    FALAssessmentDetails = '';
    subsoilCriteriaApplies3m = '';
    isAgricultural = '';
    isCommercial = '';
    isIndustrial = '';
    isNatural = '';
    isResidential = '';
    isMoreSensetiveLandWithin30m = '';
    mostSensetiveLandUse = '';
    isCoarse = '';
    isFine = '';

    waterTableDepth = '';
    thicknessOfNonAqueousPhaseLiquids = '';
    directionOfGroundWaterFlow = '';
    allSubstancesRemediatedToCriteria = '';
    humanHealthConcernsOrExceedances = '';
    onSiteSoil = '';
    onSiteGroundWater = '';
    onSiteSurfaceWater = '';
    offSiteSoil = '';
    offSiteGroundWater = '';
    offSiteSurfaceWater = '';
    airSparging = '';
    alluBucket = '';
    bioPiles = '';
    bioSparging = '';
    bioventing = '';
    chemicalOxidation = '';
    digAndDump = '';
    dualPhaseExtraction = '';
    enhancedAerobicBioRemediation = '';
    inSituGroundwaterBioRemediation = '';
    landFarming = '';
    lowTempThermalDesorption = '';
    monitoredNaturalAttenuation = '';
    soilVaporExtraction = '';
    other = '';
    approvedRMPInPlace = '';
    DUA = '';
    FAL = '';
    managementLimit = '';
    ecologicalDirectSoilContact = '';
    humanDirectSoilContact = '';
    vapourInhalation = '';
    others = '';
    administrativeControl = '';
    exposureBarriers = '';
    thirdPartyAcceptanceApproved = '';
    monitoringReportDueDate = '';
    additionalEventComments = '';
    additionalRiskManagementComments = '';
    closure = '';
    notedPotentialDeficiencies = '';
    timeForESASpecialist = '';
    initials = '';
    approvedBySeniorReviewer = '';
    notes = '';
    dateSubmitted = '';
    dateOfCommentsProvidedAHEP = '';
    dateCompletedOrApproved = '';
    dateLogged = '';

    fileClassification = '';
    documentsInFile = 0;
    coordinates: Array<Coordinates> = [];
    contaminants: Array<Contaminant> = [];
    LLD: Array<LegalLandDescription> = [];
    riskManagementData: Array<RiskManagementData> = [];
    ATSsCount = 0;
    PBLsCount = 0;

    constructor(data: SiteIO) {
        Object.assign(this, data);
        if (this.operationName.trim() === '') {
            this.operationName = '(NO OPERATION NAME)';
        }

        this.LLD = this.LLD.map((i) => new LegalLandDescription(i));
        this.contaminants = this.contaminants.map((i) => new Contaminant(i));
        this.coordinates = this.coordinates.map((i) => new Coordinates(i));
        this.riskManagementData = this.riskManagementData.map((i) => new RiskManagementData(i));

        // removing invalid LLD data
        this.LLD = this.LLD.filter((i) => i.PBL || i.ATS);

        this.ATSsCount = this.LLD.filter((i) => i.ATS).length;

        this.PBLsCount = this.LLD.filter((i) => i.PBL).length;
    }

    get fileClassificationDescription(): string {
        return fileClassifications[this.fileClassification] ?? '';
    }

    get currentSiteStatusDescription(): string {
        switch (this.currentSiteStatus) {
        case 'OPN':
            return 'Open';
        case 'PND':
            return 'Pending';
        case 'CLO':
            return 'Closed';
        case 'RSK':
            return 'Risk Managed';
        case 'CER':
            return 'Certified';
        case 'SUS':
            return 'Suspended';
        default:
            return 'Unavailable';
        }
    }

    get documentsURL(): string {
        let s = this.id || '';
        while (s.length < 8) {
            s = `0${s}`;
        }

        return `http://esar.alberta.ca/esarmain.aspx?esaid=${s}`;
    }
}
